import { createApp, nextTick } from 'vue';
import App from './App.vue';

// Disabled service worker for now.
// import './setup/service-worker';

import router from './router';
import store from './store';
import FontAwesomeIcon from './setup/fontawesome';
import HelpComponent from './components/Help.vue';
import { HttpHelper } from './helper/http';
import { GeneralHelper } from './helper/general';
import { IntlHelper } from './helper/intl';
import { AuthHelper } from './helper/auth';
import { VersionHelper } from './helper/version';
import ClickOutsideDirective from './directives/click-outside';
import Tooltip from './components/Tooltip.vue';
import '@fortawesome/fontawesome-free/js/all.js';

import { enableConnect, disableConnect } from './utils/connect';

const httpHelper = new HttpHelper(store, router);
AuthHelper.setData(store as any, httpHelper);

const CONNECT_OPTIONS = {
	workspaceId: '3172641f-13f3-4b07-a61f-b629a0e54d70',
	definitionId: 'fb5f1c64-f438-4039-be25-54b004258b16',
	layout: { verticalOffset: 80 },
};

function isModelsPath(path: string): boolean {
	return path.startsWith('/ai/models');
}

async function syncConnectForPath(path: string): Promise<void> {
	if (!isModelsPath(path)) {
		disableConnect();
		return;
	}

	// Wait until the route view has rendered, then initialise.
	await nextTick();
	requestAnimationFrame(() => {
		void enableConnect(CONNECT_OPTIONS);
	});
}

AuthHelper.validateLogin().finally(async () => {
	const response = await fetch(`/api/help/labels?t=${Date.now()}`);
	const helpIndex = await response.json();

	// Only create app once this finishes.
	const app = createApp(App)
		.use(store)
		.use(router)
		.component('fa', FontAwesomeIcon)
		.component('help', HelpComponent)
		.component('Tooltip', Tooltip)
		.directive('click-outside', ClickOutsideDirective)
		.provide('http', httpHelper)
		.provide('helper', new GeneralHelper())
		.provide('intl', new IntlHelper())
		.provide('version', new VersionHelper(store));

	app.config.globalProperties.$help = helpIndex;
	app.provide('help', helpIndex);

	app.mount('#app');

	// Ensure the initial route is ready/rendered before syncing Connect.
	await router.isReady();
	await syncConnectForPath(router.currentRoute.value.path);

	// Sync Connect on every navigation (SPA).
	router.afterEach((to) => {
		void syncConnectForPath(to.path);
	});
});
